import { createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/info/info_09_ui.png'


const _withScopeId = n => (_pushScopeId("data-v-4a60d152"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "acordion" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ demo: _ctx.demo, open: _ctx.isOpen }, "root"])
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "acordion-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    })
  ], 2)), [
    [_vShow, !_ctx.mobile]
  ])
}